module.exports = __webpack_public_path__ + "static/6-9fe3ce2971d03f3858aa71f861c2608a.png";